/**
 *
 * MeasurementHistory
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { get, filter } from "lodash"
import { Link } from "react-router-dom"
import { Input, Button, Select, Popover } from "antd"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import EmptyButton from "components/EmptyButton"
import Loader from "components/Loader"
import EmptyStateScreen from "components/EmptyStateScreen"
import ModalCustom from "components/ModalCustom"
import MeasurementHistoryTable from "components/MeasurementHistoryTable"
import {
  makeSelectIsLoadingListSurveys,
  makeSelectListSurveys,
  makeSelectIsLoadingListMeasurements,
  makeSelectListMeasurements,
  makeSelectIsLoadingHasCollaborators,
  makeSelectHasCollaborators,
} from "./selectors"
import {
  createMeasurementWatcher,
  listSurveysWatcher,
  listMeasurementsWatcher,
  deleteMeasureWatcher,
  hasCollaboratorsWatcher,
} from "./actions"
import saga from "./saga"
import reducer from "./reducer"
import measurementHistory from "../../images/measurement-history.svg"
import arrowBottomSelect from "../../images/arrow-bottom-select.svg"
import {
  PAGE_MODEL_MEASUREMENT,
  visitPageSegment,
} from "../../utils/segment/segmentTracks"
import "./index.less"
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { LOCAL_COMPANY_ID,LOCAL_MODULES } from "../../utils/storage"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class MeasurementHistory extends React.Component {
  state = {
    isOpenSelectNewMeasurement: false,
    modalNewMeasurement: false,
    titleMeasurement: "",
    searchHistoryMeasurement: "",
    surveySelected: undefined,
    metricTotalLabel: "Clima laboral",
  }

  setIntervalMeasureList = null

  componentDidMount = () => {
    if (!JSON.parse(LOCAL_MODULES()).some(module => module.slug === 'measures')) {
      this.props.history.push("/")
    }
    this.props.hasCollaboratorsWatcher()
    this.props.listSurveysWatcher()
    this.props.listMeasurementsWatcher()

    visitPageSegment(PAGE_MODEL_MEASUREMENT)

    this.setIntervalMeasureList = setInterval(() => {
      this.props.listMeasurementsWatcher()
    }, 100000000)
  }

  componentWillUnmount = () => {
    clearInterval(this.setIntervalMeasureList)
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  createMeasure = () => {
    const { titleMeasurement, surveySelected, metricTotalLabel } = this.state
    const params = {
      name: titleMeasurement,
      id_survey: surveySelected,
      metric_total_label: this.showMetricTotalLabel() ? metricTotalLabel : null,
      id_company: LOCAL_COMPANY_ID(),
    }

    this.props.createMeasurementWatcher(params)
    this.setState({
      titleMeasurement: "",
      surveySelected: undefined,
      modalNewMeasurement: false,
      metricTotalLabel: "Clima laboral",
    })
  }

  showDataBySearch = () => {
    const { searchHistoryMeasurement } = this.state

    if (searchHistoryMeasurement) {
      return filter(this.props.listMeasurements, (item) => {
        return item.name
          .toLowerCase()
          .includes(searchHistoryMeasurement.toLocaleLowerCase())
      })
    }

    return this.props.listMeasurements
  }

  showMetricTotalLabel = () => {
    const { surveySelected } = this.state
    const { listSurveys } = this.props

    let response = true
    if (surveySelected !== undefined) {
      let data = filter(listSurveys, ["id_survey", surveySelected])
      response = data[0].id_survey_type === 1
    }

    return response
  }

  render() {
    const { listMeasurements } = this.props

    if (
      typeof this.props.isLoadingListSurveys === "undefined" ||
      (!Array.isArray(listMeasurements) && !listMeasurements.length)
    ) {
      return <Loader height="100vh" />
    }
    const hasFreshchat =
    typeof window.Intercom !== "undefined" &&
    window.self === window.top;
    return (
      <React.Fragment>
        <Helmet>
          <title>Modelos - Historial de mediciones</title>
          <meta
            name="description"
            content="Description of MeasurementHistory"
          />
        </Helmet>
        {!this.props.listMeasurements.length && (
          <EmptyStateScreen
            image={measurementHistory}
            title="¡Aún no cuentas con mediciones!"
            remember="Debes tener colaboradores y cuestionarios creados para poder agendar una medición."
            description={`
              Agenda una medición para poder empezar a medir el clima laboral y
              estilo de <br /> liderazgo dentro de tu organización.
            `}>
            {get(this.props, "hasCollaborators.hasData", false) &&
              (this.props.listSurveys.length ? (
                <EmptyButton
                  size="large"
                  onClick={
                    () => {
                      woopraTrack("Nueva medición")
                      // this.setStateFrom("modalNewMeasurement", true)
                      this.props.history.push("/models/measure-new")
                    } /* this.setStateFrom("modalNewMeasurement", true) */
                  }
                  label="+ Nueva medición"
                />
              ) : (
                <Link to="/models/surveys" className="measurement-history-link">
                  Ir a Cuestionarios &gt;
                </Link>
              ))}
          </EmptyStateScreen>
        )}

        {!!this.props.listMeasurements.length && (
          <div className= {`measurement-history ${hasFreshchat ? "has-freshchat-history" : ""}`}>
            <div className="measurement-history-header">
              <div className="measurement-history-header-title">
                <div>Historial de mediciones</div>
              </div>
              <div className="measurement-history-header-actions">
                <Input
                  placeholder="Buscar..."
                  value={this.state.searchHistoryMeasurement}
                  onChange={(e) =>
                    this.setStateFrom(
                      "searchHistoryMeasurement",
                      e.target.value
                    )
                  }
                  suffix={
                    this.state.searchHistoryMeasurement ? (
                      <CloseCircleOutlined
                        onClick={() =>
                          this.setStateFrom("searchHistoryMeasurement", "")
                        }
                        style={{
                          cursor: "pointer",
                          color: "white",
                          background: "rgba(0, 0, 0, 0.25)",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <SearchOutlined />
                    )
                  }
                />
                {this.props.listSurveys.length ? (
                  <Button
                    onClick={() => {
                      woopraTrack("Nueva medición")
                      // this.setStateFrom("modalNewMeasurement", true)
                      this.props.history.push("/models/measure-new")
                    }}
                    name="nuevaMedicion"
                    type="primary">
                    + Nueva medición
                  </Button>
                ) : (
                  <Popover
                    placement="topRight"
                    content={
                      <p>
                        Se debe contar con <b>cuestionarios creados</b> para
                        <br /> poder habilitar la creación de una medición.
                      </p>
                    }
                    trigger="hover">
                    <Button
                      type="primary"
                      name="nuevaMedicion"
                      style={{ background: "#C0C0C0", borderColor: "#C0C0C0" }}
                      onClick={() => {
                        woopraTrack("Nueva medición")
                      }}>
                      + Nueva medición
                    </Button>
                  </Popover>
                )}
              </div>
            </div>
            <MeasurementHistoryTable
              deleteMeasureWatcher={this.props.deleteMeasureWatcher}
              dataSource={this.showDataBySearch()}
            />
          </div>
        )}
        <ModalCustom
          title="Nueva medición"
          model="Nueva Medición"
          disabledButton={
            !this.state.titleMeasurement ||
            !this.state.surveySelected ||
            !this.state.metricTotalLabel
          }
          showFooter
          modalOpen={this.state.modalNewMeasurement}
          textAlign="left"
          onOk={this.createMeasure}
          onOkId="aceptarMedicion"
          onCancel={() => {
            this.setState({
              modalNewMeasurement: false,
              titleMeasurement: "",
              surveySelected: undefined,
              metricTotalLabel: "Clima laboral",
            })
          }}>
          <p className="new-measurement">
            Ingresa el <span>nombre</span> de la medición que deseas crear:
          </p>
          <Input
            style={{ width: 290, marginBottom: 16 }}
            value={this.state.titleMeasurement}
            maxLength={200}
            placeholder="Ejemplo: Clima laboral 2018"
            onChange={(event) =>
              this.setStateFrom("titleMeasurement", event.target.value)
            }
            onKeyPress={(event) => {
              if (
                event.key === "Enter" &&
                this.state.titleMeasurement &&
                this.state.surveySelected
              )
                this.createMeasure()
            }}
          />
          <p className="new-measurement">
            Selecciona el <span>cuestionario</span> que deseas utilizar:
          </p>
          <Select
            showSearch
            style={{ width: 290, marginBottom: 16 }}
            placeholder="Seleccionar cuestionario"
            id="seleccionCuestionario"
            onChange={(e) => this.setStateFrom("surveySelected", e)}
            value={this.state.surveySelected}
            filterOption={(input, option) => {
              return (
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              )
            }}
            suffixIcon={
              <img
                src={arrowBottomSelect}
                style={{
                  transform: `rotate(${
                    !this.state.isOpenSelectNewMeasurement ? "0deg" : "180deg"
                  })`,
                }}
                alt="arrow-bottom-select"
              />
            }
            onDropdownVisibleChange={(open) => {
              this.setState({ isOpenSelectNewMeasurement: open })
            }}>
            {get(this.props, "listSurveys", []).map((item) => {
              return (
                <Option key={item.id_survey} value={item.id_survey}>
                  {item.name}
                </Option>
              )
            })}
          </Select>
          {this.showMetricTotalLabel() && (
            <div>
              <p className="new-measurement">
                Ingresa el nombre de la <span>variable</span> que deseas medir:
              </p>
              <Input
                style={{ width: 290 }}
                value={this.state.metricTotalLabel}
                maxLength={40}
                placeholder="Ejemplo: Clima laboral"
                onChange={(event) =>
                  this.setStateFrom("metricTotalLabel", event.target.value)
                }
                onKeyPress={(event) => {
                  if (
                    event.key === "Enter" &&
                    this.state.titleMeasurement &&
                    this.state.surveySelected &&
                    this.state.metricTotalLabel
                  )
                    this.createMeasure()
                }}
              />
            </div>
          )}
        </ModalCustom>
      </React.Fragment>
    )
  }
}

MeasurementHistory.propTypes = {
  // createMeasurementWatcher: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  // measurementHistory: makeSelectMeasurementHistory(),
  listSurveys: makeSelectListSurveys(),
  isLoadingListSurveys: makeSelectIsLoadingListSurveys(),
  isLoadingListMeasurements: makeSelectIsLoadingListMeasurements(),
  listMeasurements: makeSelectListMeasurements(),
  isLoadingHasCollaborators: makeSelectIsLoadingHasCollaborators(),
  hasCollaborators: makeSelectHasCollaborators(),
})

function mapDispatchToProps(dispatch) {
  return {
    createMeasurementWatcher: (params) =>
      dispatch(createMeasurementWatcher(params)),
    listSurveysWatcher: () => dispatch(listSurveysWatcher()),
    listMeasurementsWatcher: () => dispatch(listMeasurementsWatcher()),
    deleteMeasureWatcher: (params) => dispatch(deleteMeasureWatcher(params)),
    hasCollaboratorsWatcher: () => dispatch(hasCollaboratorsWatcher()),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "measurementHistory", reducer })
const withSaga = injectSaga({ key: "measurementHistory", saga })

export default compose(withReducer, withSaga, withConnect)(MeasurementHistory)
